
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import IResource from "@/IResource";
import IAvailability from "@/IAvailability";

@Component({})
export default class StepMultiTimeResourceCard extends Vue {

	@Prop({
		required: true,
		type: Object
	})
	public resource!: IResource;

	@Prop({
		required: true,
		type: Object
	})
	public availability!: IAvailability;

	@Prop({
		default: true,
		type: Boolean
	})
	public available!: boolean;

	@Prop({
		required: true,
		type: Number
	})
	public fromtime!: number;

	@Prop({
		required: true,
		type: Number
	})
	public totime!: number;

	public showDescription: boolean = false;

	public selectResource() {
		this.$emit('selectresource', this.resource.id);
	}

	get shortenedDescription(): string {
		if (this.resource.description && this.showMoreLink) {
			return this.resource.description.substr(0, 130)
		}
		return this.resource.description || '';
	}

	get showMoreLink(): boolean {
		if (!this.resource.description) {
			return false;
		}
		return this.resource.description.length > 150;
	}

	get dateStart(): Date {
		return this.$store.state.startdate;
	}

	get dateKeyStart() {
		let d = this.dateStart;
		return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
	}

	public minutesToTime(minutes: number): string {
		let rest = minutes % 60;
		return Math.floor(minutes / 60) + ':' + (rest < 10 ? '0' + rest : rest);
	}

	get notAvailableReason(): string {
		if (!this.available) {
			// check for min_hours_to_reservation
			let reservationStart = new Date(this.dateStart);
			reservationStart.setMinutes(reservationStart.getMinutes() + this.fromtime);

			// check mintime
			let minDate = new Date();
			minDate.setHours(minDate.getHours() + this.resource.min_hours_to_reservation);
			if (minDate > reservationStart) {
				if (this.resource.min_hours_to_reservation > 24) {
					return `Muss mindestens ${Math.round(this.resource.min_hours_to_reservation / 24)} Tage vorher gebucht werden`;
				} else {
					return `Muss mindestens ${this.resource.min_hours_to_reservation} Stunden vorher gebucht werden`;
				}
			}

			// check maxtime
			if (this.resource.max_hours_to_reservation) {
				let maxDate = new Date();
				maxDate.setHours(maxDate.getHours() + this.resource.max_hours_to_reservation);
				if (maxDate < reservationStart) {
					return `Kann maximal ${Math.round(this.resource.max_hours_to_reservation / 24)} Tage vorher gebucht werden`;
				}
			}

			// check starttime/endtime
			if (this.resource.starttime * 60 > this.fromtime || this.resource.endtime * 60 < this.totime) {
				return `Nur von ${this.minutesToTime(this.resource.starttime * 60)} bis ${this.minutesToTime(this.resource.endtime * 60)} buchbar`;
			}

			// check availability overlap
			if (this.availability[this.dateKeyStart]) {
				let overlappingSlots = this.availability[this.dateKeyStart].filter((slot) => {
					return slot[0] < this.totime && slot[1] > this.fromtime;
				})
				if (overlappingSlots.length === 1) {
					let slot = overlappingSlots[0];
					if (slot[0] > this.fromtime && slot[1] < this.totime) {
						return `Von ${this.minutesToTime(slot[0])} bis ${this.minutesToTime(slot[1])} gebucht`;
					} else {
						if (slot[0] > this.fromtime) {
							return `Nur bis ${this.minutesToTime(slot[0])} verfügbar`;
						}
						if (slot[1] < this.totime) {
							return `Erst ab ${this.minutesToTime(slot[1])} verfügbar`;
						}
					}
				}
				if (overlappingSlots.length > 1) {
					let minstart = 1440;
					let maxend = 0;
					overlappingSlots.forEach(slot => {
						if (slot[0] < minstart) {
							minstart = slot[0];
						}
						if (slot[1] > maxend) {
							maxend = slot[1];
						}
					})
					if (minstart > this.fromtime && maxend < this.totime) {
						return `Von ${this.minutesToTime(minstart)} bis ${this.minutesToTime(maxend)} gebucht`;
					} else {
						if (minstart > this.fromtime) {
							return `Nur bis ${this.minutesToTime(minstart)} verfügbar`;
						}
						if (maxend < this.totime) {
							return `Erst ab ${this.minutesToTime(maxend)} verfügbar`;
						}
					}
				}
			}

			// check max duration
			if (this.resource.max_duration > 0 && this.totime - this.fromtime > this.resource.max_duration) {
				if (this.resource.max_duration >= 120) {
					return `Maximal für ${Math.round(this.resource.max_duration / 60)}h buchbar`;
				} else {
					return `Maximal für ${this.resource.max_duration}min buchbar`;
				}
			}
			return 'Bereits gebucht';
		}
		return '';
	}

}
